import * as React from 'react';
export var FrameCircle = function FrameCircle(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", {
    transform: "translate(1633 -55.999)"
  }, React.createElement("path", {
    d: "M-1606.9,69.6h-12.5v12.5h4.2v-8.3h8.3V69.6z"
  }), React.createElement("path", {
    d: "M-1611.1,90.4h12.5V77.9h-4.2v8.3h-8.3V90.4z"
  }), React.createElement("g", {
    transform: "translate(-1633 56)"
  }, React.createElement("path", {
    d: "M24,4.2c10.9,0,19.8,8.9,19.8,19.8c0,10.9-8.9,19.8-19.8,19.8C13.1,43.8,4.2,34.9,4.2,24\n        C4.2,13.1,13.1,4.2,24,4.2 M24,0C10.7,0,0,10.7,0,24s10.7,24,24,24s24-10.7,24-24S37.3,0,24,0z"
  }))));
};